import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { SpendingActions } from './spending.actions';
import { SpendingService } from '../../services/spending.service';

@Injectable()
export class SpendingEffects {
  private actions$ = inject(Actions);
  private svc = inject(SpendingService);

  loadAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SpendingActions.loadSpendings),
      mergeMap(({ from, to }) => this.svc.getAll(from, to).pipe(
        map(spendings => SpendingActions.loadSpendingsSuccess({ spendings })),
        catchError(err => of(SpendingActions.loadSpendingsFailure({ error: err.message })))
      ))
    )
  );

  loadOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SpendingActions.loadSpending),
      mergeMap(({ id }) => this.svc.getById(id).pipe(
        map(spending => SpendingActions.loadSpendingSuccess({ spending })),
        catchError(err => of(SpendingActions.loadSpendingFailure({ error: err.message })))
      ))
    )
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SpendingActions.createSpending),
      mergeMap(({ dto }) => this.svc.create(dto).pipe(
        map(spending => SpendingActions.createSpendingSuccess({ spending })),
        catchError(err => of(SpendingActions.createSpendingFailure({ error: err.message })))
      ))
    )
  );

  update$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SpendingActions.updateSpending),
      mergeMap(({ id, dto }) => this.svc.update(id, dto).pipe(
        map(spending => SpendingActions.updateSpendingSuccess({ spending })),
        catchError(err => of(SpendingActions.updateSpendingFailure({ error: err.message })))
      ))
    )
  );

  delete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SpendingActions.deleteSpending),
      mergeMap(({ id }) => this.svc.delete(id).pipe(
        map(() => SpendingActions.deleteSpendingSuccess({ id })),
        catchError(err => of(SpendingActions.deleteSpendingFailure({ error: err.message })))
      ))
    )
  );

  loadSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SpendingActions.loadSpendingSummary),
      mergeMap(({ from, to, groupBy }) => this.svc.getSummary(from, to, groupBy ?? 'category').pipe(
        map(summary => SpendingActions.loadSpendingSummarySuccess({ summary })),
        catchError(err => of(SpendingActions.loadSpendingSummaryFailure({ error: err.message })))
      ))
    )
  );
}
